import { render } from "./alertsComp.vue?vue&type=template&id=b867e11e"
import script from "./alertsComp.vue?vue&type=script&lang=js"
export * from "./alertsComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__